/* Ascend FX: scroll reveal for sections + staggered product cards.
   Progressive enhancement: if anything here fails, content just stays visible. */
(function () {
  'use strict';
  try {
    var root = document.documentElement;
    if (root.classList.contains('shopify-design-mode')) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var main = document.getElementById('MainContent');
    if (!main) return;

    var sections = Array.prototype.filter.call(main.children, function (el) {
      return el.classList && el.classList.contains('shopify-section');
    });
    if (!sections.length) return;

    var viewportH = window.innerHeight || root.clientHeight || 800;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.remove('ascend-pre');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0, rootMargin: '0px 0px -8% 0px' }
    );

    sections.forEach(function (section, index) {
      // Number product cards so they can cascade in
      Array.prototype.forEach.call(section.querySelectorAll('product-card'), function (card, i) {
        card.style.setProperty('--ascend-i', String(i % 8));
      });

      section.classList.add('ascend-fx');

      // Anything already on screen stays visible; only below-the-fold sections wait for scroll
      var top = section.getBoundingClientRect().top;
      if (index === 0 || top < viewportH * 0.92) return;

      section.classList.add('ascend-pre');
      io.observe(section);
    });

    root.classList.add('ascend-js');
  } catch (e) {
    /* fail open: content stays visible */
  }
})();